import script from "./EditVueFlow.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditVueFlow.vue?vue&type=script&lang=ts&setup=true"

import "./EditVueFlow.vue?vue&type=style&index=0&id=1b3c5e10&lang=scss"

const __exports__ = script;

export default __exports__